//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
//#region comment metod

const GetCommentData = (params: any) =>
  request({
    url: ApiURL.Query.GetCommentData + "?" + params,
    method: RequestType.GET,
  });
const GetCommentTicketList = () =>
  request({
    url: ApiURL.Query.GetCommentTicketList,
    method: RequestType.GET,
  });
const GetCommentStatusList = () =>
  request({
    url: ApiURL.Query.GetCommentStatusList,
    method: RequestType.GET,
  });

const GetCustomer = (params: any) =>
  request({
    url: ApiURL.Query.GetCustomer + "/" + params,
    method: RequestType.GET,
  });
const RejectProductReviews = () =>
  request({
    url: ApiURL.Query.RejectProductReviews,
    method: RequestType.GET,
  });
//#endregion
const GetCommentDataV2 = (params: any) =>
  request({
    url: ApiURL.Query.GetCommentDataV2 + "?" + params,
    method: RequestType.GET,
  });
const GetCommentDataByIdV2 = (params: any) =>
  request({
    url: ApiURL.Query.GetCommentDataByIdV2 + "/" + params.id,
    method: RequestType.GET,
  });
const CommentDataDownload = (params: any) =>
  request({
    url: ApiURL.Query.GetCommentDataV2 + "?size=" + params,
    method: RequestType.GET,
  });
const CommentOperatorListV2 = () =>
  request({
    url: ApiURL.Query.CommentOperatorListV2,
    method: RequestType.GET,
  });
  const RejectPhotoReasonList = () =>
    request({
      url: ApiURL.Query.RejectPhotoReasonList,
      method: RequestType.GET,
    });
const CommentQuery = {
  GetCommentData,
  GetCommentTicketList,
  GetCommentStatusList,
  GetCustomer,
  RejectProductReviews,
  GetCommentDataV2,
  GetCommentDataByIdV2,
  CommentDataDownload,
  CommentOperatorListV2,
  RejectPhotoReasonList
};

export default CommentQuery;
